import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { Grid, TextField, Select, MenuItem, Button } from '@mui/material';
import moment from 'moment';
import api from '../../api';

@inject('cartStore', 'orderStore', 'userStore', 'commonStore')
@observer
class MemberInfo extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;

    this.state = {
      emailValidation: false,
      phoneValidation: false,
      userCardNumberValidation: false,
      zoneInfoValidation: false,
      zoneList: [
        { value: 'BAY', name: `BAY SIDE（${t('MESSAGE_ZONE_BAY')}）` },
        { value: 'STAR', name: `STAR SIDE（${t('MESSAGE_ZONE_STAR')}）` },
      ],
      blockList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      seatList: [],
      seatList1: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
      ],
      seatList2: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
    };
  }

  async componentDidMount() {
    const { userStore } = this.props;
    userStore.setUserDataFromLocalStorage();

    // 로그인 되어 있는 사용자
    if (userStore.isDasLogIn) {
      const location = window.location;
      const host = `${location.protocol}//${location.host}${
        location.host === 'localhost:3000' || location.host === 'dev.upsolution.co.kr:8200' ? '' : '/'
      }`;

      try {
        const result = await api.getDasAccessToken('', userStore.dasToken.refresh_token, host);

        userStore.dasToken = result.data;
        userStore.dasRequestDateTime = moment();
        userStore.saveDasData();
      } catch (e) {
        // 엑세스토큰을 다시 요청했을 때 에러가 발생하면 로그아웃 처리
        userStore.dasLogOut();
      }
    }

    if (userStore.isDasLogIn) {
      // 사용자 정보 요청 / userStore 사용자 정보 업데이트
      const dasUserInfoResult = await api.getDasUserInfo(userStore.dasToken.access_token);
      if (dasUserInfoResult) {
        const user = dasUserInfoResult.data;
        userStore.dasUserId = user.das_user_id;
        userStore.userData.email = user.email;
        userStore.userData.phoneNumber = user.phone_number;
        userStore.userData.userCardNumber = user.sub;
        userStore.saveDasData();
      }
    }

    // delivery order 이면서 토큰저장 12시간 이전인 경우 좌석정보 디코딩
    if (userStore.userData.deliveryType === '2' && userStore.userData.seatToken.length > 0) {
      try {
        // 인코딩된 좌석정보 요청
        const seatInfoResult = await api.getSeatInfo(userStore.userData.seatToken);
        userStore.seatInfo = seatInfoResult.data.seat;
      } catch {
        // delivery 좌석 정보 초기화
        userStore.seatInfo = '';
        userStore.userData.seatToken = '';
        userStore.userData.seatTokenDateTime = null;
        userStore.saveUserData();
      }
    }

    this.setState({ ...this.state, seatList: this.state.seatList1 });
  }

  emailValidationCheck = e => {
    const regex = /^[a-zA-Z0-9/\-/+/./_]+@(?:[a-zA-Z0-9\-/]+\.)+[A-Za-z]+$/;
    this.setState(() => {
      return {
        emailValidation:
          this.props.userStore.userData.email === ''
            ? false
            : !(this.props.userStore.userData.email && regex.test(this.props.userStore.userData.email)),
      };
    });
  };

  ChangePhoneNum = e => {
    let val = this.forceInteger(e.target.value);
    let validation = false;

    if (val === '' || val.length < 10) validation = true;
    this.props.userStore.userData.phoneNumber = val;

    this.setState(() => {
      return { phoneValidation: validation };
    });
  };

  changeUserCardNumber = e => {
    let val = this.forceInteger(e.target.value);
    let validation = false;
    if (val.length !== 10) validation = true;
    if (val.length === 0) validation = false;

    this.props.userStore.userData.userCardNumber = val;

    this.setState(() => {
      return { userCardNumberValidation: validation };
    });
  };

  forceInteger = arg => {
    return arg.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
  };

  handleZoneInfo = e => {
    const { value, name } = e.target;
    let validation = true;

    this.props.userStore.userData = { ...this.props.userStore.userData, [name]: value };

    if (this.props.userStore.userData.zone === 'BAY' && this.props.userStore.userData.block >= '8') {
      this.setState({ ...this.state, seatList: this.state.seatList2 });

      if (this.props.userStore.userData.seat < '6') this.props.userStore.userData.seat = '';
    } else {
      if (this.state.seatList.length !== 30) this.setState({ ...this.state, seatList: this.state.seatList1 });
    }

    if (
      this.props.userStore.userData.zone === '' ||
      this.props.userStore.userData.block === '' ||
      this.props.userStore.userData.seat === ''
    ) {
      validation = false;
    }

    this.setState(() => {
      return { zoneInfoValidation: validation };
    });
  };

  handleShowHideDialog = () => {
    this.props.commonStore.showHideDasDialog();
  };

  render() {
    const { emailValidation, phoneValidation, userCardNumberValidation } = this.state;
    const { t, userStore } = this.props;
    return (
      <React.Fragment>
        <Grid item container direction={'column'} spacing={3}>
          <Grid item container direction="column" spacing={1}>
            <Grid item>
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                {t('MESSAGE_CUSTOMER_INFO')} <span className="price-color">({t('MESSAGE_REQUIRED')})</span>
              </div>
              <div style={{ fontSize: '14px' }}>
                メールアドレスに誤りがある場合、通知が届きません。誤りがないか、十分ご確認いただき、入力ください。また、mobileorder.yokohama-stadium.co.jpドメインのアドレスからメールが受信できるようにしてください。
              </div>
            </Grid>
            <Grid item container direction="column" spacing={1}>
              <Grid item>
                <TextField
                  value={userStore?.userData.email ?? ''}
                  fullWidth
                  variant="outlined"
                  maxLength="20"
                  onChange={e => {
                    this.props.userStore.userData.email = e.target.value;
                  }}
                  onBlur={this.emailValidationCheck}
                  error={emailValidation}
                  label={t('MESSAGE_CUSTOMER_EMAIL')}
                  helperText={emailValidation ? t('ERROR_EMAIL_VALIDATION') : ''}
                  inputProps={{
                    maxLength: 256,
                  }}
                  required={true}
                  multiline
                  minRows={1}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }
                  }}
                />
              </Grid>
              <Grid item>
                <TextField
                  value={userStore?.userData.phoneNumber ?? ''}
                  label={t('MESSAGE_CUSTOMER_PHONE')}
                  fullWidth
                  variant="outlined"
                  error={phoneValidation}
                  required={true}
                  helperText={phoneValidation ? t('ERROR_CUSTOMER_PHONE_VALIDATION') : ''}
                  onChange={this.ChangePhoneNum}
                  inputProps={{ maxLength: 11, pattern: '[0-9]*', inputMode: 'numeric' }}
                />
              </Grid>

              {userStore.userData.deliveryType === '1' && (
                <>
                  <Grid item>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '40px' }}>
                      {t('MESSAGE_SEAT_INFO')} <span className="price-color">({t('MESSAGE_REQUIRED')})</span>
                    </div>
                    <div style={{ fontSize: '14px' }}>
                      お客様がお座りいただいている座席情報を下記から選択してください。QRコードからアクセスいただいた方は、自動で入力されておりますので、間違いがないか確認をお願いいたします。誤りがある場合は、下記より修正してください。
                      <br />
                      <font color="red">※</font>{' '}
                      商品をお届けする座席情報となります。必ず間違いがないよう、確認ください。
                      <br />
                      <font color="red">※</font>{' '}
                      本サービスの対象の座席しか選択できないようになっております。選択できないシート番号からのご注文はできません。
                    </div>
                  </Grid>
                  <Grid item container spacing={1}>
                    <Grid item xs={6}>
                      <Select
                        fullWidth
                        value={userStore?.userData.zone ?? ''}
                        onChange={this.handleZoneInfo}
                        name="zone"
                      >
                        {this.state.zoneList.map((item, idx) => (
                          <MenuItem value={item.value} key={idx}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={3}>
                      <Select
                        fullWidth
                        value={userStore?.userData.block ?? ''}
                        onChange={this.handleZoneInfo}
                        name="block"
                      >
                        {this.state.blockList.map((item, idx) => (
                          <MenuItem value={item} key={idx}>
                            {item}段
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={3}>
                      <Select
                        fullWidth
                        value={userStore?.userData.seat ?? ''}
                        onChange={this.handleZoneInfo}
                        name="seat"
                      >
                        {this.state.seatList.map((item, idx) => (
                          <MenuItem value={item} key={idx}>
                            {item}番
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>
                </>
              )}

              {userStore.userData.deliveryType === '2' && (
                <>
                  <Grid item>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '40px' }}>
                      {t('MESSAGE_SEAT_INFO')} <span className="price-color">({t('MESSAGE_REQUIRED')})</span>
                    </div>
                    <div style={{ fontSize: '14px' }}>
                      お届けする座席情報は以下となります。BAYSTARS STAR
                      GUIDEで登録済みの電子チケットの座席情報が表示されております。お間違い無いことをご確認ください。
                      <br />
                      <font className="price-color">※ </font>間違いがある場合は、BAYSTARS STAR
                      GUIDEの電子チケットを確認していただき、再度アクセスしてください
                    </div>
                  </Grid>

                  <Grid item>
                    <TextField
                      fullWidth
                      value={userStore.seatInfo ?? ''}
                      label={t('MESSAGE_SEAT_INFO')}
                      variant="outlined"
                      required={false}
                      error={!userStore?.userData.seatToken}
                      helperText={!userStore?.seatInfo ? t('MESSAGE_SEAT_INFO_ERROR') : ''}
                      multiline={true}
                      focused
                      inputProps={{ readOnly: true }}
                      color="secondary"
                    />
                  </Grid>
                </>
              )}

              {/* 로그인 되어 있을 경우 */}
              {userStore.isDasLogIn && (
                <Grid item>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '40px' }}>
                    BlueMates{t('MESSAGE_CUSTOMER_INFO2')}
                    <span style={{ color: 'red' }}>（{t('MESSAGE_AUTO_INPUT')}）</span>
                  </div>
                  <div style={{ fontSize: '14px', paddingTop: '5px' }}>
                    <div>
                      ログインしているDeNAアカウントに紐づいたBAYSTARS
                      ID会員番号が自動で反映されます。必ず表示内容をご確認ください。
                      <br />
                      当年度BlueMates会員の方は、購入金額により STARを獲得することができます。
                    </div>
                    <div style={{ paddingTop: '5px' }}>
                      <div style={{ paddingBottom: '5px' }}>
                        <font className="price-color">※ </font>BlueMatesに加入前の注文についてはSTARは付与されません
                      </div>

                      <div style={{ paddingBottom: '5px' }}>
                        <font className="price-color">※ </font>
                        注文後のBAYSTARS
                        ID会員番号の後付けや、変更は受け付けておりません。間違いがないようにご注意ください
                      </div>

                      <div style={{ paddingBottom: '5px' }}>
                        <font className="price-color">※ </font>
                        STARは、注文日の翌日に付与されます。Blue Mates会員マイページ上で、STAR付与をご確認ください
                      </div>

                      {userStore.userData.deliveryType === '2' && (
                        <div style={{ paddingBottom: '5px' }}>
                          <font className="price-color">※ </font>
                          配送手数料はSTAR還元の対象外（計算外）となります。ご了承ください
                        </div>
                      )}
                    </div>
                  </div>

                  <Grid item>
                    <div style={{ marginTop: '5px', color: 'red' }}>BAYSTARS ID 会員番号（修正不可）</div>
                    <TextField
                      fullWidth
                      value={userStore?.userData.userCardNumber ?? ''}
                      // label={t('MESSAGE_CUSTOMER_CODE2')}
                      variant="outlined"
                      error={userCardNumberValidation}
                      required={false}
                      helperText={userCardNumberValidation ? t('ERROR_CUSTOMER_CARDNUM_VALIDATION') : ''}
                      inputProps={{
                        maxLength: 10,
                        pattern: '[0-9]*',
                        inputMode: 'numeric',
                        readOnly: true,
                      }}
                      onChange={this.changeUserCardNumber}
                      focused
                      color="secondary"
                    />
                  </Grid>
                </Grid>
              )}

              {/** 로그인이 되어 있지 않을 경우 */}
              {!userStore.isDasLogIn && (
                <Grid item>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '40px' }}>BlueMates会員の方</div>
                  <div style={{ fontSize: '14px', paddingTop: '5px' }}>
                    <div>
                      BlueMates会員番号の手動入力サービスは終了いたしました。STAR付与には、DeNAアカウントログインでの購入が必要となります。下記より、ログインしてご購入ください
                    </div>
                    <div style={{ paddingTop: '5px' }}>
                      <div style={{ paddingBottom: '5px' }}>
                        <font className="price-color">※ </font>
                        ログインすると、カート情報が空になる可能性があります。その際は再度商品をお選びください
                      </div>
                    </div>
                  </div>

                  <div style={{ textAlign: 'center' }}>
                    <Button color={'primary'} variant={'contained'} onClick={this.handleShowHideDialog}>
                      {t(userStore.isDasLogIn ? 'BUTTON_LOGOUT' : 'BUTTON_LOGIN')}
                    </Button>
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withTranslation()(MemberInfo);
